import { render } from "./PacienteCita03.vue?vue&type=template&id=25e49250&scoped=true"
import script from "./PacienteCita03.vue?vue&type=script&lang=js"
export * from "./PacienteCita03.vue?vue&type=script&lang=js"

import "@/assets/css/wizardResumen.css?vue&type=style&index=0&id=25e49250&scoped=true&lang=css"
import "./PacienteCita03.vue?vue&type=style&index=1&id=25e49250&scoped=true&lang=css"

import exportComponent from "C:\\Software\\Aplicaciones\\kiatros\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e49250"]])

export default __exports__